<template>
<div>
    <BaseModal :config="ProgramModalLabel" @ResetFields="resetFields" @SaveChanges="saveChanges">
    <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
         <ProgramForm ref="refProgramForm" :displayErrors="DispError" :disabled="false" :ProgramInfo="ProgramInfoFormConfig" :ProgramLabel="''" @UnitClassDeleteitem="UnitClassDeleteitem"  @VestingDeleteitem="VestingDeleteitem"></ProgramForm>                   
    </div>        
    </BaseModal>
</div>
</template>

<script>
import $ from 'jquery';
// import BaseModelProgram from "@/models/BaseModelProgram.js";
import ProgramForm from "@/components/forms/ProgramForm.vue";
import BaseModal from "@/components/base/BaseModal.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import { mapActions, mapGetters } from 'vuex';
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import { isNullOrUndefined } from 'util';
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";
export default {
    name: "ProgramInfoForm",
    props: ["ProgramInfoFormConfig", "ProgramModalLabel", "UnitClassDeleteItemsArray", "VestingDeleteItemsArray","UploadedFile"],
    mixins:[apiUtil,funcUtil,DocumentManagerMixin],
    computed: {
        ...mapGetters("getModule", ["withFilter"]),
    },
    data: function () {
        return {            
            BaseModelVestingSchedule:BaseModelVestingSchedule,
            BaseModelUnitClass:BaseModelUnitClass,
            DispError: false,
            BaseModelProgram:BaseModelProgram,
            bulkUploadAuditConfig: bulkUploadAuditConfig
        };
    },
    components: {
        BaseModal,
        BaseGrid,
        ProgramForm
    },
    mounted(){
        // alert(JSON.stringify(this.ProgramInfoFormConfig));
        this.resetFields();
        $('#BaseModal').on('shown.bs.modal', function () {
           // $self.callDisableFunctions();
            $('input:text:visible:first', this).focus();
        })
    },
    methods: {
        ...mapActions("postModule",["CreateAllItems","deleteAllItem","UpdateAllItems","CreateJoinedItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),
        isDataSourceDirty: function(DataSource) {
            let DataSourceDirty = false;
            DataSourceDirty = DataSource._data.some(obj =>{                
                if(obj.dirty === true){
                    return true;
                }
            });
            return DataSourceDirty;
        },
  
        UnitClassDeleteitem: function(e)
        {
        e.preventDefault();
        let gview = window.$("#ProgramClassInfoGrid").data("kendoGrid");

            const message ="Are you sure you want to delete this record?";
            this._ConfirmationPopup(message,"DELETE").then((result) => {
                if(result.value) {
                                        
                    let dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
                    if(dataItem.Id != 0 && dataItem.Id != null && dataItem.Id != undefined)
                    { 
                      this.UnitClassDeleteItemsArray.push({"Id": dataItem.Id});                      
                    }
                    let row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");                        
                    gview.removeRow(row);     
                                   
                }            
            });
        // }
        
        },
        VestingDeleteitem: function(e)
        {
        e.preventDefault();
        let gview = window.$("#ProgramVestingScheduleGrid").data("kendoGrid");

            const message ="Are you sure you want to delete this record?";
            this._ConfirmationPopup(message,"DELETE").then((result) => {
                if(result.value) {
                    let dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
                    if(dataItem.Id != 0 && dataItem.Id != null && dataItem.Id != undefined)
                    { 
                      this.VestingDeleteItemsArray.push({"Id": dataItem.Id});                       
                    }
                    let row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");                        
                    gview.removeRow(row);                    
                }                   
            });
        // }
        
        },
        getConfirmation: function () {
            let retVal = confirm("Are you sure you want to delete this record?");
            if (retVal == true) return true;
            else return false;
        },
        GetCurrentGridData(gridId) {
            console.log(`Getting grid data for gridId [${gridId}]`);
            const grid = $("#" + gridId).data("kendoGrid");
            let gridArray = [];
            let gridData = grid.dataSource.data();
            for (let i = 0; i < gridData.length; i++) {
                let element = gridData[i];
                gridArray.push(element)
            }
            return gridArray;
            //console.log(this.ProgramInfoTemplate)
        },

        async saveChanges() {
            console.log("the uploaded file is ",this.UploadedFile)
            let self = this;
            this.DispError = true;
            let gviewUnitClass = window.$("#ProgramClassInfoGrid").data("kendoGrid");
            let gviewVestingSchedule = window.$("#ProgramVestingScheduleGrid").data("kendoGrid");
            //Read current data from the Grid
            this.ProgramInfoFormConfig.children.UnitClass =  this.GetCurrentGridData("ProgramClassInfoGrid");
            this.ProgramInfoFormConfig.children.VestingSchedule =  this.GetCurrentGridData("ProgramVestingScheduleGrid");

                if (this.$refs.refProgramForm.Validate()) {
                    if (this.ProgramModalLabel.modalAddorEdit == "add") {
                        // Add Popup
                        console.log(JSON.stringify(this.ProgramInfoFormConfig));
                        let addFormValues= this.ProgramInfoFormConfig;
                        if(this.ProgramInfoFormConfig.parent.IncomeSource != null || this.ProgramInfoFormConfig.parent.IncomeSource != undefined)
                        addFormValues.parent.IncomeSource = this.ProgramInfoFormConfig.parent.IncomeSource.toString();
                        if(this.ProgramInfoFormConfig.parent.StateSource != null || this.ProgramInfoFormConfig.parent.StateSource != undefined)
                        addFormValues.parent.StateSource = this.ProgramInfoFormConfig.parent.StateSource.toString();  
                        
                        addFormValues.parent.InvestmentId=this.ProgramInfoFormConfig.parent.InvestmentId[0];
                        addFormValues.parent.EIN = (addFormValues.parent.EIN)?addFormValues.parent.EIN.toString():null

                        if(this.ProgramInfoFormConfig.parent.FormationDate == ""){
                            addFormValues.parent.FormationDate = null;
                        }

                        // US #1179 : Program ID
                        const result = this.withFilter(self.BaseModelProgram.list, "");

                        if (result.length <= 0) {
                            addFormValues.parent.ProgramID = 300001;
                            } else {
                            //let lastElement = _.last(result);
                            addFormValues.parent.ProgramID = self._getIncrementalID(result,"ProgramID");
                        }

                        let joinedItems = { "joinedObject" : {
						    parentConfig: BaseModelProgram, 				
                            childConfigs: [BaseModelVestingSchedule, BaseModelUnitClass]                            
                        }, "createData": addFormValues,"ParentKey": "ProgramId" }

                        //let loader = this.$loading.show();
                        this._APICrudPopup("APICrudpopup");
                        this.CreateJoinedItems(joinedItems).then((response) => {
                            //refresh the grid data only after the update gets completed
                           $("#programGrid").data().kendoGrid.dataSource.read();

                          if((!isNullOrUndefined(self.UploadedFile)) && (self.UploadedFile !=""))
                          {
                            //this._AlertPopup("Saved Successfully!","success");
                          /** AUDIT DOCUMENT UPLOAD **/
                            //  let selectedFile = { ...grid.dataItem(this) };
                            let FileUpload = [];
                            let senderObj = {};
                            //senderObj.Id = this.count++;
                            
                            let realfileName =  this.UploadedFile.name;
                            senderObj.File =  this.UploadedFile.upload.uuid
                            senderObj.RealFileName = realfileName;
                            senderObj.FileContent = this.UploadedFile
                            FileUpload.push(senderObj);
                  
                            this.UploadBulkAditFilesToDB(FileUpload)
                                .then(response => {
                                self._AlertPopup("Saved Successfully!","success");
                                })
                                .catch(error => {
                                self._AlertPopup("Some Error Occurred!", "info");
                                })
                                .finally(() => {
                                    // self.UploadedFile="";
                                //loader.hide();
                                });
                       /** AUDIT DOCUMENT UPLOAD END */
                          }
                          else{
                               self._AlertPopup("Saved Successfully!","success");
                          }
                      
                        }).catch(error=>{
                            this._AlertPopup("Some Error Occurred!","info");
                        }).finally(()=>{
                            //loader.hide();
                        });
                    
                    } else {
                        // Edit Popup
                        
                        console.log(JSON.stringify(this.ProgramInfoFormConfig));
                        const editForm= this.ProgramInfoFormConfig.parent;
                        if (this.ProgramInfoFormConfig.parent.IncomeSource != null || this.ProgramInfoFormConfig.parent.IncomeSource != undefined){
                            editForm.IncomeSource = this.ProgramInfoFormConfig.parent.IncomeSource.toString();
                        }
                        
                        if(this.ProgramInfoFormConfig.parent.StateSource != null || this.ProgramInfoFormConfig.parent.StateSource != undefined){
                            editForm.StateSource = this.ProgramInfoFormConfig.parent.StateSource.toString();
                        }

                        editForm.InvestmentId=this.ProgramInfoFormConfig.parent.InvestmentId[0];
                        editForm.EIN = (editForm.EIN)?editForm.EIN.toString():null
                        if(this.ProgramInfoFormConfig.parent.FormationDate == ""){
                            editForm.FormationDate = null;
                        }

                        let editFormUnitClass = this.ProgramInfoFormConfig.children.UnitClass;
                        let editFormVesting = this.ProgramInfoFormConfig.children.VestingSchedule;
                        const editFormArray = [];
                       
                        editFormArray.push(editForm);

                        //let loader = this.$loading.show();
                        this._APICrudPopup("APICrudpopup");

                        //Deleted unit class items in edit form
                        let deletedobject = null;
                        if(this.UnitClassDeleteItemsArray.length>0 && this.VestingDeleteItemsArray.length>0 ){
                            deletedobject = {                             
                                UnitClass: {config: BaseModelUnitClass, deleteData: this.UnitClassDeleteItemsArray},
                                VestingSchedule: {config: BaseModelVestingSchedule, deleteData: this.VestingDeleteItemsArray}
                            };
                        }else if(this.UnitClassDeleteItemsArray.length>0 && this.VestingDeleteItemsArray.length==0 ){
                            deletedobject = {                             
                                UnitClass: {config: BaseModelUnitClass, deleteData: this.UnitClassDeleteItemsArray}
                            };
                        }else if(this.UnitClassDeleteItemsArray.length==0 && this.VestingDeleteItemsArray.length>0 ){
                            deletedobject = {  
                                VestingSchedule: {config: BaseModelVestingSchedule, deleteData: this.VestingDeleteItemsArray}
                            };
                        }

                        if(deletedobject != null){
                            // let loader = this.$loading.show();
                            let deleteResponse = await this.deleteAllItem(deletedobject)
                        }

                        //added unit class items in edit form
                        let addedunitclassArray = [];
                        addedunitclassArray=this.getaddeditems(editFormUnitClass);
                        addedunitclassArray.forEach(element => {
                            element.ProgramId =  editForm.Id;
                        });

                        //added vesting schedule items in edit form
                        let addedVestingArray = [];
                        addedVestingArray=this.getaddeditems(editFormVesting);
                        addedVestingArray.forEach(element => {
                            element.ProgramId =  editForm.Id;
                        });

                        //using Create All method for newly added unit class and Vesting schedule info
                        let createdobject = null;
                        if(addedunitclassArray.length>0 && addedVestingArray.length>0 ){
                            createdobject = {                             
                             UnitClass: {config: BaseModelUnitClass, createData: addedunitclassArray},
                             VestingSchedule: {config: BaseModelVestingSchedule, createData: addedVestingArray}
                            };
                        }else if(addedunitclassArray.length>0 && addedVestingArray.length==0 ){
                             createdobject = {                             
                             UnitClass: {config: BaseModelUnitClass, createData: addedunitclassArray}
                            };
                        }else if(addedunitclassArray.length==0 && addedVestingArray.length>0 ){
                             createdobject = {                             
                             VestingSchedule: {config: BaseModelVestingSchedule, createData: addedVestingArray}
                            };
                        }
                        
                        if(createdobject != null){
                            // let loader = this.$loading.show();
                            let createResponse = await this.CreateAllItems(createdobject);
                        }

                        //Remove added items from update JSON
                        editFormUnitClass = this.removeAddedItemsforUpdate(editFormUnitClass);
                        editFormVesting = this.removeAddedItemsforUpdate(editFormVesting);

                        //using Update All method
                        let updateobject = {
                             Program: {config: BaseModelProgram, updateData: editFormArray},
                             UnitClass: {config: BaseModelUnitClass, updateData: editFormUnitClass},
                             VestingSchedule: {config: BaseModelVestingSchedule, updateData: editFormVesting}
                        };
                        
                        this.UpdateAllItems(updateobject).then(res => {
                            $("#programGrid").data().kendoGrid.dataSource.read();
                            this._AlertPopup("Saved Successfully!","success");
                        }).catch(error=>{
                            this._AlertPopup("Some Error Occurred!","info");
                        }).finally(()=>{
                            //loader.hide();
                        })

                    }
                    // alert("Data Saved Successfully!");
                    $("#BaseModal").modal("toggle");
                    
                    this.resetFields();
                }
                else{
                    let basemodal = $("#BaseModal");
                    $("input:text:visible:first", basemodal).focus();
                }
        },
        removeAddedItemsforUpdate:function(objdata){
            let filteredData= objdata.filter(function(e) {
				return (
                    e["Id"] != 0 && e["Id"] != null && e["Id"] != undefined
                    )
			});
			return filteredData;	
        },

        getaddeditems:function(objdata){
            let filteredData= objdata.filter(function(e) {
				return (
                    e["Id"] == 0 || e["Id"] == null || e["Id"] == undefined
                    )
			});
			return filteredData;			
        },
        resetFields: function () {
            this.$refs.refProgramForm.pageErrors = [];
            this.DispError = false;
             this.$refs.refProgramForm.errors.clear();   

        }
    }
};
</script>

<style lang="scss" scoped>

</style>
